module.exports = __webpack_public_path__ + "img/137 - 19CEB524 Md Ali Gauhar (1).4e4b4c22.jpg";